
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BaseBlockViewObject } from '@/types/apiServerContract';
import SeoHeader from '@/core/seo/SeoHeader.vue';

@Component({
    components: {
        SeoHeader
    }
})
export default class BaseBlock extends Vue {
	@Prop({
	    required: true,
	    type: Object
	})
	content!: BaseBlockViewObject;

	@Prop({
	    required: true,
	    type: Boolean
	})
	isFirstBlock!: boolean;

	protected get backgroundColor() {
	    return this.content.backgroundColor;
	}

	protected get backgroundImage() {
	    return this.content.backgroundImage;
	}

	protected get borderRadius() {
	    return `${this.content.borderRadius}px`;
	}

	protected get backgroundStyle() {
	    let style = `
			background-color: ${this.backgroundColor};
			border-radius: ${this.borderRadius};
			padding: ${this.content.padding};
		`;

	    if (this.backgroundImage) {
	        style += `
			background-image: url('${this.backgroundImage}');
			background-position: center;
			background-repeat: no-repeat;
			background-size: 100% 100%;`;
	    }

	    return style;
	}
}
